/**
 * Internal utilities for the Stellar Attest Protocol SDK
 * 
 * This module exports all internal utilities organized by context:
 * - Schema utilities (UID generation, formatting)
 * - Test data generation functions
 * - Stellar-specific utilities (keypairs, addresses)
 * - Standardized schema encoders
 * - Validation functions
 * - Schema encoder core functionality
 */

// Schema utilities
export * from './schema-utils'

// Schema encoder core (main encoder classes and types)
export * from './schema-encoder'